
import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

@Component({ name: 'StrategyGuide' })
export default class IndexView extends Vue {
  @Prop({ type: String, default: '' }) text!: string
  strategyGuideClick() {
    this.$emit('guide-click', '')
  }
}
